module.exports = __webpack_public_path__ + "static/media/60.ef7838bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/60.jpg
// module id = 428
// module chunks = 0